import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';
import { IAuthorSalesResponseDto } from '../book.dto';

export const useAuthorSales = (author: string) => {
  const {
    book: { getAuthorSales }
  } = useServices();

  const res = useQuery<IAuthorSalesResponseDto>(
    ['get-author-sales', author],
    () => getAuthorSales(author),
    {
      enabled: Boolean(author)
    }
  );

  return {
    data: res.data,
    isError: res.isError,
    isLoading: res.isLoading
  };
};
